
import React from 'react';
import { Input } from '@/components/ui/input';
import { DollarSign } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { FilterSection } from './FilterSection';

interface RevenueFilterProps {
  minValue: string;
  maxValue: string;
  onMinValueChange: (value: string) => void;
  onMaxValueChange: (value: string) => void;
  isMobile: boolean;
}

export const RevenueFilter: React.FC<RevenueFilterProps> = ({
  minValue,
  maxValue,
  onMinValueChange,
  onMaxValueChange,
  isMobile
}) => {
  return (
    <FilterSection id="min-value" label="Revenue">
      <div className={`flex flex-row space-x-2 ${isMobile ? 'w-full' : ''}`}>
        <div className={isMobile ? 'w-full flex-1' : 'w-40'}>
          <div className="relative flex items-center border border-input rounded-md">
            <div className="flex items-center pl-3">
              <DollarSign className="h-4 w-4 text-gray-500" />
              <Separator orientation="vertical" className="h-4 mx-1" />
            </div>
            <Input 
              id="min-value"
              type="number" 
              placeholder="is above" 
              value={minValue}
              onChange={(e) => onMinValueChange(e.target.value)}
              className="h-10 text-sm border-none pl-1 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-none focus:outline-none focus:ring-0"
            />
          </div>
        </div>
        
        {isMobile && <span className="flex items-center text-gray-400">-</span>}
        
        <div className={isMobile ? 'w-full flex-1' : 'w-40'}>
          <div className="relative flex items-center border border-input rounded-md">
            <div className="flex items-center pl-3">
              <DollarSign className="h-4 w-4 text-gray-500" />
              <Separator orientation="vertical" className="h-4 mx-1" />
            </div>
            <Input 
              id="max-value"
              type="number" 
              placeholder="is below" 
              value={maxValue}
              onChange={(e) => onMaxValueChange(e.target.value)}
              className="h-10 text-sm border-none pl-1 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-none focus:outline-none focus:ring-0"
            />
          </div>
        </div>
      </div>
    </FilterSection>
  );
};
